import React from 'react';
import useInView from '../hooks/useInView';

const Contact = () => {
  const [ref, inView] = useInView();

  return (
    <section id="contact" className="py-20 md:py-32 px-6 md:px-12 max-w-6xl mx-auto border-t border-neutral-200 dark:border-white/10">
      <div
        ref={ref}
        className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
      >
        <div className="md:col-span-4">
          <h2 className="text-xs font-mono uppercase tracking-widest text-neutral-500 mb-4">
            04 / Contact
          </h2>
          <div className="h-px bg-neutral-200 dark:bg-white/20 w-12 hidden md:block"></div>
        </div>

        <div className="md:col-span-8 flex flex-col items-start gap-6 md:gap-8 mt-4 md:mt-0">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-neutral-900 dark:text-white mb-2 leading-tight">
            Construisons quelque chose <br className="hidden md:block" />
            d’exceptionnel ensemble.
          </h2>
          <p className="text-base md:text-lg text-neutral-600 dark:text-neutral-400 max-w-lg mb-4 md:mb-6">
            Je suis actuellement ouvert à de nouvelles opportunités, projets freelance et collaborations.
            N’hésitez pas à me contacter si vous avez un projet intéressant en tête.
          </p>

          <a
            href="mailto:romain.goudergues@gmail.com"
            className="w-full sm:w-auto text-center justify-center group relative px-6 md:px-8 py-4 bg-neutral-900 text-white dark:bg-white dark:text-black font-semibold tracking-wide hover:bg-neutral-800 dark:hover:bg-neutral-200 transition-colors duration-200 inline-flex items-center gap-4"
          >
            Me contacter
            <span className="transform group-hover:translate-x-1 transition-transform">
              →
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
